import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import "./ReferenceRows.sass";
import { BsTrash, BsCameraVideo } from "react-icons/bs";
import { BiCloudUpload } from "react-icons/bi";
import { btnTranslate, referenceTranslate } from "../../../../i18n/translatedMessages";
import { FormattedMessage } from "react-intl";

function ReferenceRows({ data, index, handleChange, handleDelete, setPdf, handlePatch }) {
  const { name, level, company, relation, phone, email, pdfName, videoLink, pdf } = data;
  const onDrop = useCallback((acceptedFiles) => {
    const [targetFile] = acceptedFiles;
    setPdf({ index: index, file: targetFile });
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxFiles: 1,
    accept: ".pdf",
  });
  return (
    <div key={index} className="accordion-item mb-3 border ReferenceRows">
      <h2 className="accordion-header" id={`headingItem${index}`}>
        <button
          className="accordion-button btnAccordion collapsed fw-bolder"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#collapseItem${index}`}
          aria-expanded="false"
          aria-controls={`collapseItem${index}`}
        >
          {name ? name : referenceTranslate.namePersona}
        </button>
      </h2>
      <div
        id={`collapseItem${index}`}
        className="accordion-collapse collapse collapseReference"
        aria-labelledby={`headingItem${index}`}
        data-bs-parent="#accordionReference"
      >
        <div className="accordion-body container-fluid">
          <div className="row row-cols-2">
            <div className="col">
              <FormattedMessage id="namePersonaPH">
                {(msg) => (
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => handleChange(index, e)}
                    name="name"
                    placeholder={msg}
                    className="form-control inputReference"
                  />
                )}
              </FormattedMessage>
            </div>
            <div className="col">
              <FormattedMessage id="function">
                {(msg) => (
                  <input
                    type="text"
                    value={level}
                    onChange={(e) => handleChange(index, e)}
                    name="level"
                    placeholder={msg}
                    className="form-control inputReference"
                  />
                )}
              </FormattedMessage>
            </div>
            <div className="col">
              <FormattedMessage id="companyWorkTogetherPH">
                {(msg) => (
                  <input
                    type="text"
                    value={company}
                    onChange={(e) => handleChange(index, e)}
                    name="company"
                    placeholder={msg}
                    className="form-control inputReference"
                  />
                )}
              </FormattedMessage>
            </div>
            <div className="col">
              <select
                value={relation}
                onChange={(e) => handleChange(index, e)}
                name="relation"
                className="form-control inputReference text-muted"
              >
                <FormattedMessage id="workRelation">
                  {(msg) => <option value={0}>{msg}</option>}
                </FormattedMessage>
                <FormattedMessage id="workRelation1">
                  {(msg) => <option value={"Par"}>{msg}</option>}
                </FormattedMessage>
                <FormattedMessage id="workRelation2">
                  {(msg) => <option value={"Equipo"}>{msg}</option>}
                </FormattedMessage>
                <FormattedMessage id="workRelation3">
                  {(msg) => <option value={"Jefe"}>{msg}</option>}
                </FormattedMessage>
                <FormattedMessage id="workRelation4">
                  {(msg) => <option value={"Ninguna"}>{msg}</option>}
                </FormattedMessage>
              </select>
            </div>
            <div className="col">
              <FormattedMessage id="phoneReference">
                {(msg) => (
                  <input
                    type="text"
                    value={phone}
                    onChange={(e) => handleChange(index, e)}
                    name="phone"
                    placeholder={msg}
                    className="form-control inputReference"
                  />
                )}
              </FormattedMessage>
            </div>
            <div className="col">
              <FormattedMessage id="emailReference">
                {(msg) => (
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => handleChange(index, e)}
                    name="email"
                    placeholder={msg}
                    className="form-control inputReference"
                  />
                )}
              </FormattedMessage>
            </div>
            <div className="col">
              {pdf ? (
                <div className="inputReference pdf">
                  <a href={`${pdf}`} target="_blank" rel="noreferrer">
                    <BiCloudUpload className="me-4" size={20} /> {pdfName}
                  </a>
                </div>
              ) : (
                <div className="inputReference pdf" {...getRootProps()}>
                  {pdfName ? (
                    <BiCloudUpload className="me-4" size={20} /> + { pdfName }
                  ) : (
                    <>
                      <input {...getInputProps()} />
                      {isDragActive ? (
                        "Suelta el PDF aquí ..."
                      ) : (
                        <div className="text-muted">
                          <BiCloudUpload className="me-4" size={20} />
                          {referenceTranslate.recomendationLetter}
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>

            <div className="col">
              <div className="input-group">
                <span className="input-group-text inputReference video" id="basic-addon1">
                  <BsCameraVideo />
                </span>
                <FormattedMessage id="recomendationVideo">
                  {(msg) => (
                    <input
                      type="text"
                      className="form-control inputReference video"
                      value={videoLink}
                      name="videoLink"
                      placeholder={msg}
                      onChange={(e) => handleChange(index, e)}
                    />
                  )}
                </FormattedMessage>
              </div>
              <div className="mb-2">
                <small className="text-muted">{referenceTranslate.videoTextReference}</small>
              </div>
            </div>
          </div>
          <div className="col-4 offset-8 text-end">
            <button
              className="btn btnGuardar px-5 py-2 fw-bolder rounded-pill me-3"
              onClick={() => handlePatch(index)}
            >
              {btnTranslate.saveButton}
            </button>
            <button className="btn btnDelete p-2 rounded-3" onClick={handleDelete}>
              <BsTrash size={22} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ReferenceRows;
